import { bemComponent } from '@99designs/common/utils/app';

export default bemComponent('spinner-container');
